export default __webpack_public_path__ + "static/media/arlington-logo.0b9f2b5b.jpg";